import { array } from "valibot"

import { BaseApiService, KyOptions } from "@finq/app-base/composables/services/api.service"

import {
  MyPensionPortfolioPolicy,
  myPensionExclusionSchema,
  myPortfolioInfoSchema,
} from "@finq/pension-portfolio/types/portfolio"

export class PensionPortfolioServiceRaw extends BaseApiService {
  getMyPortfolioPolicies = (config: KyOptions = {}) => {
    return this.instance.get("/pensions/portfolio/policies", config).then((res) => {
      const data = res.data.data as MyPensionPortfolioPolicy[]
      // try {
      //   return this.parsePaginated(
      //     { data, paging: { index: 0, size: data.length, total: data.length } },
      //     array(myPortfolioItemSchema)
      //   )
      // } catch (e) {
      //   console.error(e)

      return { data, paging: { index: 0, size: data.length, total: data.length } }
      // }
    })

    // .then((data) => {
    //   return { data, paging: { index: 0, size: data.length, total: data.length } }
    // })
  }

  getMyDeposits = (policyId: number, config: KyOptions = {}) => {
    return this.instance.get(`/pensions/portfolio/policies/${policyId}/deposits`, config).then(this.getData)
  }

  getPortfolioInfo = (config: KyOptions = {}) => {
    return this.instance
      .get("/pensions/portfolio", config)
      .then(this.getData)
      .then((data) => this.parse(data, myPortfolioInfoSchema))
  }

  getValuePropositionCalculation = (config: KyOptions = {}) => {
    return this.instance.get("/pensions/portfolio/value-proposition", config).then(this.getData)
  }

  getValuePropositionTableData = (config: KyOptions = {}) => {
    return this.instance.get("/pensions/portfolio/value-proposition/table-data", config).then(this.getData)
  }

  getUserExclusions = (config: KyOptions = {}) => {
    return this.instance
      .get("/pensions/portfolio/exclusions", config)
      .then(this.getData)
      .then((data) => this.parse(data, array(myPensionExclusionSchema)))
  }
}

export const PensionPortfolioService = new PensionPortfolioServiceRaw()
